import {
  trackClickExternalLocationCodeButtonGroupButtonLandingPage,
  trackClickExternalLocationCodeButtonLandingPage,
  trackClickLocationCodeButtonLandingPage,
  trackLocationDropdownSelectionLandingPage,
  trackSearchLocationCodeLandingPage,
  trackSearchAddressLandingPage,
} from 'integrations/segment/tracking-events/BOSLandingPage';
import Location from 'models/Location';

export const getLocationsInDropdown = (locations: Location[], components: any[]) => {
  const locationButtonComponents = components?.filter((component) => component.type === 'LocationButton');
  const locationIdsOfButtons = locationButtonComponents?.map((component) => component.props.locationId);
  return locations?.filter((location) => !locationIdsOfButtons.includes(location.locationId) && !location.external_url);
};

export const onRedirect = (externalUrl?: string) => {
  trackClickExternalLocationCodeButtonLandingPage({
    external_url: externalUrl,
  });
  window.open(externalUrl);
};

const handleTracking = (locationCode: string, componentType: string) => {
  const params = {
    locationShortId: locationCode,
  };
  switch (componentType) {
    case 'LocationSearch':
      trackSearchLocationCodeLandingPage(params);
      break;
    case 'AddressSearch':
      trackSearchAddressLandingPage(params);
      break;
    case 'LocationDropdown':
      trackLocationDropdownSelectionLandingPage({
        locationShortId: locationCode,
        dropdown_type: 'regular',
      });
      trackLocationDropdownSelectionLandingPage({
        ...params,
        dropdown_type: 'regular',
      });
      break;
    case 'CateringLocationDropdown':
      trackLocationDropdownSelectionLandingPage({
        ...params,
        dropdown_type: 'catering',
      });
      break;
    case 'LocationButtonGroup':
      trackClickExternalLocationCodeButtonGroupButtonLandingPage(params);
      break;
    case 'LocationButton':
      trackClickLocationCodeButtonLandingPage(params);
      break;
    default:
      break;
  }
};

export const onSubmit = (locationCode: string, componentType: string, history: any) => {
  if (!locationCode) {
    return;
  }
  handleTracking(locationCode, componentType);

  history.push(`/${locationCode}`);
};
